"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/hartwall/hartwall.scss');
const index_1 = require("./../js/index");
const hartwall_1 = require("./Sites/hartwall");
const ProductsApp_hartwall_1 = require("./ReactComponents/Products/ProductsApp-hartwall");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Import site specific scripts
(0, hartwall_1.InitHartwall)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
// Initialize and mount react components
(0, index_1.InitReact)(Object.assign(Object.assign({}, index_1.DefaultComponentTypes), { ProductsApp: ProductsApp_hartwall_1.default }));
